<template>
	<div class="item-message">
		<div class="message-list">
			<div v-for="(ite,index) in tabData.data" :key="index">
				<div  @click="tiDetail(ite)" class="message-item" :class="[!tabItem.noDetail&&'pointer']">
					<p style="position: relative;">
						<span v-if="ite.is_ready==2" class="yuan" style=""></span>
						<span v-if="tabItem.messageLabel" style="color: #1E9FFF;">{{ tabItem.messageLabel }}</span>
						<span style="font-weight: bold;">{{ite.title}}</span>
					</p>
					<p>
						<span class="small-text" style="white-space: pre-wrap">{{ite.desc}}</span>
					</p>
					<p>
						<span style="padding-left: 10px;font-weight: 400;font-size: 12px;color: #555555;">{{ite.created_time}}</span>
					</p>
				</div>
			</div>
			
			<div v-if="tabData.data&&tabData.data.length<10&&tabData.data.length!=0" style="width: 100%;text-align: center;font-size: 14px;margin-top: 10px;">
				到底了～</div>
				<div v-if="tabData.data&&tabData.data.length==0" style="width: 100%;text-align: center;font-size: 14px;margin-top: 10px;">
					暂无消息～</div>
			<div class="fenye">
				<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :total="tabData.total">
				</el-pagination>
			</div>
		</div>

	</div>
</template>
<script>
	import {
		mapMutations,
		mapState,
		mapActions
	} from 'vuex'
	export default {
		name: 'itemMessage',
		data() {
			return {
				page: 1,
				page_size: 10,
				tabData: { // 列表数据
					data: [],
					total: 0
				}
			}
		},
		props: ['tabItem'],
		created() {
			this.getMessageData()
		},
		computed: {
			// ...mapState('message', ['stateIndexOne', 'stateIndexTwo', 'stateIndexThree']),
		},

		methods: {
			...mapActions('message', ['messageIndex']),
			// ...mapMutations('message', ['mutationsIndexOne', 'mutationsIndexTwo', 'mutationsIndexThree']),
			handleClick(tab, event) {
				console.log(tab, event);
			},
			tiDetail(ite) {
				if(this.tabItem.noDetail) return
				this.$router.push({
					path:  this.staticPath + "detailMessage",
					query:{
						id:ite.id
					}
				})
			},
			handleCurrentChange(val) {
				this.page = val
				this.getMessageData()
			},
			async getMessageData() {
				let obj = {}
				// console.log(458, this.tabItem);
				obj.mtype = this.tabItem.index
				obj.page = this.page
				obj.page_size = this.page_size

				let res = await this.messageIndex(obj)
				this.tabData.data = res.data || []
				this.tabData.total = res.total || 0

				console.log('getMessageData-res:',res)
				// if (this.tabItem.index == 0) {
				// 	await this.mutationsIndexOne(res)
				// } else if (this.tabItem.index == 1) {
				// 	this.mutationsIndexTwo(res)
				// } else if (this.tabItem.index == 2) {
				// 	this.mutationsIndexThree(res)
				// }
				// if (this.tabItem.index == 0) {
				// 	this.tabData = this.stateIndexOne
				// } else if (this.tabItem.index == 1) {
				// 	this.tabData = this.stateIndexTwo
				// } else if (this.tabItem.index == 2) {
				// 	this.tabData = this.stateIndexThree
				// }
				// console.log(785911, res);

			}
		}
	}
</script>
<style lang="less" scoped>
	.message-list {
		width: 925px;
		min-height: 200px;
		border-radius: 4px;
		border: 1px solid rgba(215, 215, 215, 1);
		padding: 10px;
	}

	.message-item {
		min-height: 79px;
		background-color: rgba(245, 247, 250, 1);
		padding: 5px;
		box-sizing: border-box;
		font-size: 13px;
		margin-top: 10px;
		&.pointer{
			cursor: pointer;
		}
		.small-text {
			display: block;
			font-weight: 400;
			color: #555555;
			padding-left: 70px;
			line-height: 20px;
			padding-top: 5px;
			padding-bottom: 5px;
		}

		.yuan {
			background-color: #d9001b;
			border-radius: 50%;
			width: 5px;
			height: 5px;
			position: absolute;
			top: 0;
			left: 5px;
		}
	}

	.fenye {
		width: 100%;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
	}
</style>
